module.exports = __webpack_public_path__ + "static/img/detail-friendW.144cee53.png";